module.exports = __webpack_public_path__ + "img/btn_magazine_off.31f0ca4c.png";